var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('px-dashboard-filtro'),_c('px-select-date-range',{attrs:{"initial-date-selection":_vm.dateSelection},on:{"change":_vm.onChangeDate}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }